export default __webpack_public_path__ + "static/media/print.8e0a0819.png";